import { Component, ElementRef, HostListener, inject, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FooterComponent } from "../shared/footer/footer.component";
import { RouterLink } from "@angular/router";
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-home',
    imports: [CommonModule, FooterComponent, RouterLink],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    host: { 'class': 'home-page' }
})
export class HomeComponent implements OnInit {

  private meta = inject(Meta);
  private title = inject(Title);

  cardDifferent = [
    {
      title: 'Easy ordering and delivery',
      img: 'assets/images/landing/home/different/1.webp',
      url: ''
    },
    {
      title: 'The best tasting food',
      img: 'assets/images/landing/home/different/2.webp',
      url: ''
    },
    {
      title: 'Over 1,000+ local products',
      img: 'assets/images/landing/home/different/3.webp',
      url: ''
    },
    {
      title: 'Sustainably grown, ethically raised',
      img: 'assets/images/landing/home/different/4.webp',
      url: ''
    },
    {
      title: 'Sustainable delivery, low waste',
      img: 'assets/images/landing/home/different/5.webp',
      url: ''
    },
    {
      title: 'Healthy food for all',
      img: 'assets/images/landing/home/different/6.webp',
      url: ''
    },
  ]

  testimonials = [
    {
      star: 5,
      quote: 'Philly Foodworks is amazing. I have a hard time when I have to buy produce at the grocery store now, it just doesn\'t compare. The fresh eggs in particular are fantastic. Plus I get to feel good about supporting local farms.',
      name: 'Kathryn S.',
      subTitle: ''
    },
    {
      star: 5,
      quote: 'Easy to order and amazing quality food from local producers. It\'s the only grocery run we need in our house and it comes right to us.Plus they take back the boxes/packaging to reuse which feels good.',
      name: 'Lauren K',
      subTitle: ''
    },
    {
      star: 5,
      quote: 'Great selection of local produce. Deliveries have always been made without a hitch. I appreciate that they serve Delco in addition to Philly proper. Their website allows you to select Favorites for easy reordering which I find helpful. No complaints!',
      name: 'Jazmin J',
      subTitle: ''
    },
    {
      star: 5,
      quote: 'I love Philly Foodworks!! It literally does not get easier to get local food delivered to my door. The ordering cut-off times are fair, the selections are good, and they\'re very easy to work with whenever I needed to update my address or had any questions.',
      name: 'Pam S',
      subTitle: ''
    },
    {
      star: 5,
      quote: 'Philly foodworks is very convenient. You can customize the box as much as you want and skip a week easily. The website is very straightforward. The produce is always good. These shenandoah pears were huge and very juicy.',
      name: 'Caroline T',
      subTitle: ''
    },
  ]

  sections: HTMLElement[] = [];

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.setUpSEOTags();
    // Retrieve all sections
    const sectionElements = this.elementRef.nativeElement.querySelectorAll('.has-animation');
    this.sections = Array.from(sectionElements);
  }

  private setUpSEOTags() {

    const { mainTitle, mainDescription, baseKeywords: keywords, baseURL, type } = environment.config.seo;
    const url = 'home';

    // Page title
    this.title.setTitle(mainTitle);

    // Standart <meta> tag for SEO
    this.meta.addTag({ name: 'description', content: mainDescription });
    this.meta.addTag({ name: 'keywords', content: keywords.join(', ') });

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: mainTitle });
    this.meta.addTag({ property: 'og:description', content: mainDescription });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }

  @HostListener('scroll', ['$event'])
  onElementScroll(event: any) {
    const scrollPosition = event.target.scrollTop;
    const windowHeight = event.target.clientHeight;

    // Loop through each section
    this.sections.forEach(section => {
      const sectionOffset = section.offsetTop;
      const sectionHeight = section.offsetHeight;

      // Check if the section is in the viewport
      if (scrollPosition >= sectionOffset - windowHeight && scrollPosition < sectionOffset + sectionHeight) {
        // Add a class to the section
        this.renderer.addClass(section, 'animated');
      } else {
        // Remove the class from the section
        this.renderer.removeClass(section, 'animated');
      }
    });
  }
}


